export default {
  "faq-container": "_faq-container_14vlyt",
  "text-container": "_text-container_14vlyt",
  "icon-container": "_icon-container_14vlyt",
  "description": "_description_14vlyt"
};
